<div class="value-with-label" [ngClass]="classes" [ngStyle]="{'padding': padding}">
  <span class="label">{{ uppercaseLabel ? (label | uppercase) : label }}</span>
  <span class="value">
    {{ uppercaseValue ? (value | uppercase) : value }}
  </span>
</div>